import { Component } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../application";
import { Home } from "../home";

@Component({
    module: FIQAssist,
    selector: SearchTab.selector,
    templateUrl: "views/searchtab.html",
    require: {
        application: "^application",
        home:"^home"
    }
})

export class SearchTab {
    private home:Home;
    private application:Application;
    public static selector = "searchTab";
    constructor(){

    }
    public get fullMenu(){
        return this.home.fullMenu;
    }
}